import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useSubCategoriesDocumentDetails } from "./usefulltips.hooks";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import Upload, { RcFile } from "antd/lib/upload";
import { Button, Modal, Typography } from "antd";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";

const AddEditusefullTip = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const [uploadModal, setUploadModal] = useState<{
      visible: boolean;
      fieldName?: string;
      file?: RcFile;
      uploading?: boolean;
      setValue?: (name: string, value: string) => void;
    }>({
      visible: false,
      fieldName: undefined,
      file: undefined,
      uploading: false,
    });
  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const epcApplicationsFormConfig: FormConfig = {
  initialValues: {
    title:
      decodeHTML(editSubCategoriesById?.payload?.title) ||
      decodeHTML(editSubCategories?.title) ||
      "",
    description:
      decodeHTML(editSubCategoriesById?.payload?.description) ||
      decodeHTML(editSubCategories?.description) ||
      "",
    title_malay:
      decodeHTML(editSubCategoriesById?.payload?.title_malay) ||
      decodeHTML(editSubCategories?.title_malay) ||
      "",
    title_mandarin:
      decodeHTML(editSubCategoriesById?.payload?.title_mandarin) ||
      decodeHTML(editSubCategories?.title_mandarin) ||
      "",
    description_malay:
      decodeHTML(editSubCategoriesById?.payload?.description_malay) ||
      decodeHTML(editSubCategories?.description_malay) ||
      "",
    description_mandarin:
      decodeHTML(editSubCategoriesById?.payload?.description_mandarin) ||
      decodeHTML(editSubCategories?.description_mandarin) ||
      "",
    link:
      decodeHTML(editSubCategoriesById?.payload?.link) ||
      decodeHTML(editSubCategories?.link) ||
      "",
    published:
      editSubCategoriesById?.payload?.published ??
      editSubCategories?.published ??
      false,
    airports:
  (
    decodeHTML(editSubCategoriesById?.payload?.airports) ||
    decodeHTML(editSubCategories?.airports) ||
    ""
  )
    .split(",")
    .map((a: any) => a.trim())
    .filter(Boolean),
    image: editSubCategoriesById?.payload
      ? [
          {
            uid: "-1",
            name: "useful-tips.jpg",
            status: "done",
            url: decodeHTML(editSubCategoriesById?.payload?.image),
          },
        ]
      : editSubCategories
      ? [
          {
            uid: "-1",
            name: "useful-tips.jpg",
            status: "done",
            url: decodeHTML(editSubCategories?.image),
          },
        ]
      : "",
  },
    fields: fields.usefulTipsPageList?.map((field: any) =>{
          if (field.uploadTrigger) {
          return {
            ...field,
            openUpload: (fieldName: string, setValue: (name: string, value: string) => void) => {
              setUploadModal({
                visible: true,
                fieldName,
                setValue,
                file: undefined,
                uploading: false,
              });
            },
            usedFileType: ".pdf"
          };
        }
        return field;
        }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    if (Array.isArray(data.airports)) {
      data.airports = data.airports.join(", ");
    }

    const payload = {
      action: action,
      method: method,
      module: "Home Page",
      subModule: "usefulTips_usefulTipsPageList",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
      },
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Useful Tips`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/useful-tips-crud-api-data/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/create-useful-tips-crud-api-data`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Homepage"
      />
      {/* ------------------- UPLOAD POPUP ------------------- */}
      <Modal
        title="Redirect URL Guide"
        open={uploadModal.visible}
        footer={null}
        onCancel={() => setUploadModal({ ...uploadModal, visible: false, file: undefined })}
        width={520}
      >
        <Typography.Paragraph style={{ marginBottom: 12 }}>
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            <li>Use <code>/example</code> for pages within this application.</li>
            <li>Use a full link for external websites (example: <code>https://example.com</code>).</li>
            <li>Want to use a file? Click <strong>Upload</strong> and paste the link.</li>
          </ol>
        </Typography.Paragraph>

        <Upload.Dragger
          accept="*"
          multiple={false}
          showUploadList={false}
          beforeUpload={(file) => {
            setUploadModal((s) => ({ ...s, file }));
            return false;
          }}
        >
          {uploadModal.file ? (
            <p className="ant-upload-text">{uploadModal.file.name}</p>
          ) : (
            <>
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file here</p>
            </>
          )}
        </Upload.Dragger>

        <div style={{ marginTop: 16, textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!uploadModal.file || uploadModal.uploading}
            onClick={async () => {
              if (!uploadModal.file || !uploadModal.fieldName || !uploadModal.setValue) return;

              setUploadModal((s) => ({ ...s, uploading: true }));

              const formData = new FormData();
              formData.append("upload-file", uploadModal.file);
              formData.append("application", "PASSENGER");

              try {
                const res: any = await post("management/upload-file", formData);
                const url = res?.response?.data;
                if (url) {
                  uploadModal.setValue(uploadModal.fieldName, url);
                  openToast({ content: `File uploaded: ${url}`, type: "success" });
                }
              } catch (e) {
                openToast({ content: "Upload failed", type: "error" });
              } finally {
                setUploadModal({ visible: false, fieldName: undefined, file: undefined, uploading: false });
              }
            }}
          >
            {uploadModal.uploading ? (
              <>
                <LoadingOutlined /> Uploading…
              </>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </Modal>
    </ContentWrapper>
  );
};

export default AddEditusefullTip;
